import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStorageService } from '@core/services/auth-storage.service';
import { PostLoginRedirectService } from '@core/services/post-login-redirect.service';
import { isTokenExpired } from '@shared/helpers/is-token-expired';

/**
 * Route guard that checks if the user is authenticated with a valid token.
 * If not authenticated or the token is expired, redirects to the login page.
 *
 * Usage in routes: canActivate: [AuthGuard]
 */
export const AuthGuard: CanActivateFn = (_route, state) => {
  const authStorageService = inject(AuthStorageService);
  const postLoginRedirectService = inject(PostLoginRedirectService);

  const authData = authStorageService.getAuthData();

  if (!authData || isTokenExpired(new Date(authData.expiresAt))) {
    authStorageService.clearAuthData();
    if (postLoginRedirectService.shouldKeepInitialUrl()) {
      return postLoginRedirectService.createLoginUrlTree(state.url);
    }

    return postLoginRedirectService.createLoginUrlTree();
  }

  return true;
};
